import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#878FA2",
      "stroke-width": "2",
      d: "M3 12.184c0-2.06 0-3.09.467-3.944.468-.853 1.321-1.383 3.029-2.443l1.8-1.117C10.1 3.56 11.003 3 12 3c.997 0 1.9.56 3.704 1.68l1.8 1.117c1.708 1.06 2.561 1.59 3.029 2.443.467.854.467 1.884.467 3.944v1.369c0 3.51 0 5.266-1.054 6.356C18.89 21 17.194 21 13.8 21h-3.6c-3.394 0-5.091 0-6.146-1.09C3 18.818 3 17.062 3 13.552v-1.37Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#878FA2",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M9 15c.85.63 1.885 1 3 1s2.15-.37 3-1"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "HomeSmile"}) } }